module.exports = __webpack_public_path__ + "static/heromobile-d59384243269cd1d69f52e702f442cb1.jpg";